import { createContext, useContext } from 'react';

/**
 * The term the header search hands to whatever page is on screen when the
 * user presses Enter — as opposed to `query` in SearchContext, which drives
 * the jump-to-record dropdown.
 *
 * It lives in its own leaf module rather than inside SearchContext because
 * DataTable is the consumer, and SearchContext reaches into TeamContacts for
 * its index, which imports DataTable — importing SearchContext from DataTable
 * would close that loop. Nothing here imports anything but React, so it can
 * be pulled in from anywhere.
 *
 * SearchProvider owns the state and mounts the provider; useSearch() is still
 * the way to *set* the filter.
 */
export const PageFilterContext = createContext<string>('');

/**
 * The active page filter, or '' when there is no provider above — shared UI
 * shouldn't have to care whether global search is mounted.
 */
export const usePageFilter = (): string => useContext(PageFilterContext);
